// GWINS Gear Mock Data
// This file contains all mock data for the frontend-only implementation

export const newsItems = [
  { id: 1, title: "New Pro Series Jerseys Now Available!", link: "/news/1" },
  { id: 2, title: "GWINS Army Media Contest - Win $500 Store Credit", link: "/news/2" },
  { id: 3, title: "2025 Tournament Season Sponsorships Open", link: "/news/3" },
];

export const featuredProducts = [
  {
    id: 1,
    name: "Pro Tactical Jersey",
    category: "Jerseys",
    price: 79.99,
    image: "https://images.unsplash.com/photo-1623025807953-63a3f0a7ddc9?w=400&h=400&fit=crop",
    badge: "Best Seller",
    customizable: true,
  },
  {
    id: 2,
    name: "Elite Combat Jersey",
    category: "Jerseys",
    price: 89.99,
    image: "https://images.unsplash.com/photo-1759872138838-45bd5c07ddc6?w=400&h=400&fit=crop",
    badge: "New",
    customizable: true,
  },
  {
    id: 3,
    name: "Tactical Joggers",
    category: "Joggers",
    price: 64.99,
    image: "https://images.pexels.com/photos/669281/pexels-photo-669281.jpeg?w=400&h=400&fit=crop",
    badge: null,
    customizable: false,
  },
  {
    id: 4,
    name: "Pro Mask System",
    category: "Accessories",
    price: 124.99,
    image: "https://images.unsplash.com/photo-1661332885103-d27b14f6d1a7?w=400&h=400&fit=crop",
    badge: "Popular",
    customizable: false,
  },
];

export const merchProducts = [
  // Products are now managed via Admin Dashboard
  // This array is kept for backwards compatibility but not used
];

export const whyGwinsFeatures = [
  {
    id: 1,
    icon: "Layers",
    title: "Pro-Quality Fabrics",
    description: "Premium athletic materials that perform under pressure",
  },
  {
    id: 2,
    icon: "Shield",
    title: "Reinforced Stitching",
    description: "Double-stitched seams built to withstand intense gameplay",
  },
  {
    id: 3,
    icon: "Wind",
    title: "Lightweight Mesh",
    description: "Breathable performance mesh for maximum mobility",
  },
  {
    id: 4,
    icon: "DollarSign",
    title: "Accessible Pricing",
    description: "Pro-quality gear at prices every player can afford",
  },
];

export const referralStats = {
  totalClicks: 1247,
  ordersGenerated: 89,
  totalCommission: 892.50,
  pendingPayout: 156.00,
  paidOut: 736.50,
  commissionRate: 10,
};

export const mockTeams = [
  {
    id: 1,
    name: "NY Aces",
    logo: "https://customer-assets.emergentagent.com/job_tactical-sports/artifacts/0c5nukgd_NY%20Aces%20Logo.jpg",
    members: 10,
    location: "New York, NY",
    sponsored: true,
    featured: true,
    socials: {
      instagram: "https://www.instagram.com/nyacespb",
      facebook: "https://www.facebook.com/share/1FyY4qssF1/",
      youtube: "https://youtube.com/@nyacespb",
    },
    description: "NXL Northeast Division competitors. Official GWINS Gear sponsored team. Dominating the paintball scene since day one.",
  },
  {
    id: 2,
    name: "Phantom Squad",
    logo: "https://images.unsplash.com/photo-1560343090-f0409e92791a?w=100&h=100&fit=crop",
    members: 12,
    location: "Miami, FL",
    sponsored: true,
    featured: false,
    socials: {},
    description: "Southeast regional champions.",
  },
  {
    id: 3,
    name: "Night Hawks",
    logo: "https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=100&h=100&fit=crop",
    members: 8,
    location: "Dallas, TX",
    sponsored: false,
    featured: false,
    socials: {},
    description: "Rising stars in the Texas paintball scene.",
  },
  {
    id: 4,
    name: "Viper Elite",
    logo: "https://images.unsplash.com/photo-1614680376408-81e91ffe3db7?w=100&h=100&fit=crop",
    members: 15,
    location: "Los Angeles, CA",
    sponsored: true,
    featured: false,
    socials: {},
    description: "West coast tournament specialists.",
  },
];

export const mockMediaGallery = [
  {
    id: 1,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_tactical-sports/artifacts/neo4ig8h_NY%20Aces%20Team.jpg",
    author: "NY Aces",
    team: "NY Aces",
    likes: 234,
    isSponsored: true,
    caption: "NY Aces squad ready for battle - NXL Tournament",
  },
  {
    id: 2,
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_tactical-sports/artifacts/157p1moy_NY%20Aces%20%20Team%202.jpg",
    author: "NY Aces",
    team: "NY Aces",
    likes: 198,
    isSponsored: true,
    caption: "Breaking through the bunker - pure adrenaline",
  },
  {
    id: 3,
    type: "image",
    url: "https://images.unsplash.com/photo-1606567595334-d39972c85dfd?w=600&h=400&fit=crop",
    author: "NY Aces",
    team: "NY Aces",
    likes: 156,
    isSponsored: true,
    caption: "Victory celebration at World Cup",
  },
  {
    id: 4,
    type: "image",
    url: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=400&fit=crop",
    author: "Mike R.",
    team: "Phantom Squad",
    likes: 67,
    isSponsored: true,
    caption: "Field domination",
  },
  {
    id: 5,
    type: "image",
    url: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=400&fit=crop",
    author: "Sarah M.",
    team: "Community",
    likes: 45,
    isSponsored: false,
    caption: "Weekend warriors",
  },
  {
    id: 6,
    type: "image",
    url: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=600&h=400&fit=crop",
    author: "NY Aces",
    team: "NY Aces",
    likes: 203,
    isSponsored: true,
    caption: "Ready for battle - NXL 2025",
  },
];

export const navLinks = [
  { label: "Community", href: "/community" },
  { label: "GWINS Army", href: "#army" },
  { label: "Shop", href: "#shop" },
  // { label: "Custom Gear", href: "#custom" }, // Hidden until ready
  { label: "Referrals", href: "#referrals" },
];
